import React, { useState } from "react";
import clienteAxios from "../../axios";

const ModalAgregarCliente = ({ show, onClose, onPersonaAgregada }) => {
    const [nuevaPersona, setNuevaPersona] = useState({
        nombre: "", razonsocial: "", direccion: "", codigopostal: "", telefono: "",
        fax: "", email: "", rfc: "", credito: "", usarcostosasignados: 0,
        usarenpoliza: 0, tipo_persona: "Cliente", idcuentacontable: "",
        nombrebanco: "", nocuenta: "", cuentaclave: "", estatus: 1
    });

    const handleAgregarPersona = async (e) => {
        e.preventDefault();

        // Validación de campos requeridos
        if (!nuevaPersona.nombre || !nuevaPersona.razonsocial || !nuevaPersona.telefono) {
            alert("Los campos de Nombre, Razón Social y Teléfono son requeridos.");
            return;
        }


        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "personas",
                ...nuevaPersona
            });



            if (response.data && response.data.result === 200 && response.data.data) {

                onPersonaAgregada();
                onClose();
                setNuevaPersona({
                    nombre: "", razonsocial: "", direccion: "", codigopostal: "", telefono: "",
                    fax: "", email: "", rfc: "", credito: "", usarcostosasignados: 0,
                    usarenpoliza: 0, tipo_persona: "Cliente", idcuentacontable: "",
                    nombrebanco: "", nocuenta: "", cuentaclave: "", estatus: 1
                });

            } else {

                alert("Hubo un error al agregar la persona. Verifica los datos e intenta nuevamente.");
            }
        } catch (error) {
            console.error("Error en la solicitud al servidor:", error);
            alert("Hubo un error en la conexión al servidor. Intenta nuevamente.");
        }

    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Agregar Nuevo Cliente</h2>
                <form onSubmit={handleAgregarPersona}>

                    <input
                        type="text"
                        value={nuevaPersona.nombre}
                        onChange={(e) => setNuevaPersona({ ...nuevaPersona, nombre: e.target.value })}
                        placeholder="Nombre"
                        className="border rounded-lg p-2 mb-2 w-full"
                    />

                    <input
                        type="text"
                        value={nuevaPersona.razonsocial}
                        onChange={(e) => setNuevaPersona({ ...nuevaPersona, razonsocial: e.target.value })}
                        placeholder="Razón Social"
                        className="border rounded-lg p-2 mb-2 w-full"
                    />
                    <input
                        type="text"
                        value={nuevaPersona.direccion}
                        onChange={(e) => setNuevaPersona({ ...nuevaPersona, direccion: e.target.value })}
                        placeholder="Dirección"
                        className="border rounded-lg p-2 mb-2 w-full"
                    />
                    <input
                        type="text"
                        value={nuevaPersona.codigopostal}
                        onChange={(e) => {
                            const input = e.target.value;
                            // Solo permitir números
                            if (/^\d*$/.test(input)) {
                                setNuevaPersona({ ...nuevaPersona, codigopostal: input });
                            }
                        }}
                        placeholder="Codigo Postal"
                        inputMode="numeric" // Sugiere al teclado solo números en dispositivos móviles
                        className="border rounded-lg p-2 mb-2 w-full"
                    />
                    <input
                        type="text"
                        value={nuevaPersona.telefono}
                        onChange={(e) => {
                            const input = e.target.value;
                            // Solo permitir números y limitar a 10 caracteres
                            if (/^\d*$/.test(input) && input.length <= 10) {
                                setNuevaPersona({ ...nuevaPersona, telefono: input });
                            }
                        }}
                        placeholder="Teléfono"
                        maxLength="10" // Limita la longitud máxima a 10 caracteres
                        className="border rounded-lg p-2 mb-2 w-full"
                    />

                    <input
                        type="text"
                        value={nuevaPersona.fax}
                        onChange={(e) => {
                            const input = e.target.value;
                            // Solo permitir números
                            if (/^\d*$/.test(input)) {
                                setNuevaPersona({ ...nuevaPersona, fax: input });
                            }
                        }}
                        placeholder="Fax"
                        inputMode="numeric" // Sugiere al teclado solo números en dispositivos móviles
                        className="border rounded-lg p-2 mb-2 w-full"
                    />
                    <input
                        type="email"
                        value={nuevaPersona.email}
                        onChange={(e) => setNuevaPersona({ ...nuevaPersona, email: e.target.value })}
                        placeholder="Email"
                        className="border rounded-lg p-2 mb-2 w-full"
                    />
                    <input
                        type="text"
                        value={nuevaPersona.rfc}
                        onChange={(e) => setNuevaPersona({ ...nuevaPersona, rfc: e.target.value })}
                        placeholder="RFC"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={20}
                    />
                    <input
                        type="text"
                        value={nuevaPersona.credito}
                        onChange={(e) => {
                            const input = e.target.value;
                            // Solo permitir números
                            if (/^\d*$/.test(input)) {
                                setNuevaPersona({ ...nuevaPersona, credito: input });
                            }
                        }}
                        placeholder="Crédito"
                        inputMode="numeric"
                        className="border rounded-lg p-2 mb-2 w-full"
                    />
                    <input
                        type="text"
                        value={nuevaPersona.nombrebanco}
                        onChange={(e) => setNuevaPersona({ ...nuevaPersona, nombrebanco: e.target.value })}
                        placeholder="Nombre del Banco"
                        className="border rounded-lg p-2 mb-2 w-full"
                    />
                     <input
                        type="text"
                        value={nuevaPersona.nocuenta}
                        onChange={(e) => {
                            const input = e.target.value;
                            // Solo permitir números
                            if (/^\d*$/.test(input)) {
                                setNuevaPersona({ ...nuevaPersona, nocuenta: input });
                            }
                        }}
                        placeholder="Número de cuenta"
                        inputMode="numeric"
                        className="border rounded-lg p-2 mb-2 w-full"
                    />
                     <input
                        type="text"
                        value={nuevaPersona.cuentaclave}
                        onChange={(e) => {
                            const input = e.target.value;
                            // Solo permitir números
                            if (/^\d*$/.test(input)) {
                                setNuevaPersona({ ...nuevaPersona, cuentaclave: input });
                            }
                        }}
                        placeholder="Clabe interbancaria"
                        inputMode="numeric"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={20}
                    />
                    <div className="flex justify-end">
                        <button type="submit" className="bg-green-500 rounded text-white px-4 py-2 mr-2">
                            Agregar
                        </button>
                        <button type="button" onClick={onClose} className="bg-gray-500 rounded text-white px-4 py-2">
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarCliente;
